window.theme.component('header', el => {
    /**
     * Vars
     */
    const mobileMenuToggler = el.querySelector('.js-mobile-menu-toggler');
    const secondaryMenuToggler = el.querySelector('.js-secondary-menu-toggler');
    const mobileMenu = el.querySelector('.js-mobile-menu');
    const secondaryMenu = el.querySelector('.js-secondary-menu');

    const menuLinks = el.querySelectorAll('.js-nav-item > a');
    const toggleButtons = el.querySelectorAll('.js-mobile-menu-toggler .component-icon');
    const actionLinks = el.querySelectorAll('.action-links.main .component-button');

    const scrollLock = {
        isLocked: () => document.body.classList.contains('scroll-lock'),
        lock: () => document.body.classList.add('scroll-lock'),
        unlock: () => document.body.classList.remove('scroll-lock'),
    };

    const megaMenus = [];
    let closeTimeout;

    el.querySelectorAll('.js-nav-item.has-sub-menu, .mobile-nav .js-megamenu-toggle[data-sub-menu-type="megamenu"]').forEach(navItem => {
        const index = navItem.dataset.index;
        const type = navItem.dataset.subMenuType;
        let viewport = navItem.dataset.viewport;
        let megaMenuId = navItem.dataset.megamenu;
        let element = el.querySelector(`.js-megamenu[data-megamenu-element="${megaMenuId}"]`);

        if (type === 'dropdown') {
            viewport = 'desktop';
            megaMenuId = index;
            element = el.querySelector(`.js-dropdown[data-index="${index}"]`);
        }

        megaMenus.push({
            index,
            type,
            viewport,
            toggler: navItem,
            element
        });
    });

    const dropdownLinks = el.querySelectorAll('.js-dropdown .link');
    dropdownLinks.forEach(link => {
        link.addEventListener('click', event => {
            event.stopPropagation();
        });
    });

    // ✅ Helper: close the secondary menu if open
    function closeSecondaryMenu() {
        if (secondaryMenuToggler && secondaryMenuToggler.classList.contains('active')) {
            secondaryMenuToggler.classList.remove('active');
            secondaryMenu.classList.remove('active');
            el.classList.remove('secondary-menu-active');
            secondaryMenuToggler.setAttribute('aria-expanded', 'false');
            scrollLock.unlock();
        }
    }

    function checkAnyMegaMenuHovered() {
        return megaMenus.some(menu =>
            menu.toggler.matches(':hover') || menu.element.matches(':hover')
        );
    }

    function openMegaMenu(megaMenu, event) {
        if (event) event.preventDefault();
        clearTimeout(closeTimeout);

        // 👉 Close secondary menu if it's open
        closeSecondaryMenu();

        if (megaMenu.element.classList.contains('active')) {
            return;
        }

        megaMenus.forEach(menu => {
            if (menu.element !== megaMenu.element && menu.element.classList.contains('active')) {
                closeMegaMenu(menu);
            }
        });

        el.timeout = setTimeout(() => {
            el.classList.add('active');
            megaMenu.toggler.classList.add('active');
            megaMenu.element.classList.add('active');
            megaMenu.toggler.setAttribute('aria-expanded', 'true');
            megaMenu.element.removeAttribute('tabindex');

            if (megaMenu.type === 'megamenu') scrollLock.lock();

            document.addEventListener('keydown', mainMenuEscape);

            if (!el.classList.contains('mobile-menu-active')) {
                toggleButtons.forEach(button => {
                    button.setAttribute('class', button.getAttribute('class').replace('-dark', '-light'));
                });

                actionLinks.forEach(button => {
                    button.setAttribute('class', button.getAttribute('class').replace('-light', ' light'));
                });
            }

            const event = new Event('megaMenuOpened');
            megaMenu.element.dispatchEvent(event);
        }, 0);
    }

    function closeMegaMenu(megaMenu) {
        clearTimeout(el.timeout);

        // 👉 Close secondary menu if it's open
        closeSecondaryMenu();

        megaMenu.toggler.classList.remove('active');
        megaMenu.element.classList.remove('active');
        megaMenu.toggler.setAttribute('aria-expanded', 'false');
        megaMenu.element.setAttribute('tabindex', '-1');

        if (scrollLock.isLocked()) scrollLock.unlock();

        megaMenu.toggler.focus();

        document.removeEventListener('keydown', mainMenuEscape);

        const anyStillHoveredOrOpen = megaMenus.some(menu =>
            menu.element.classList.contains('active') ||
            menu.toggler.matches(':hover') ||
            menu.element.matches(':hover')
        );
        if (!anyStillHoveredOrOpen) {
            el.classList.remove('active');
        }

        if (!el.classList.contains('mobile-menu-active')) {
            toggleButtons.forEach(button => {
                button.setAttribute('class', button.getAttribute('class').replace('-light', '-dark'));
            });

            actionLinks.forEach(button => {
                button.setAttribute('class', button.getAttribute('class').replace(' light', '-light'));
            });
        }
    }

    function mainMenuEscape(event) {
        const openedMegaMenu = megaMenus.find(menu => menu.element.classList.contains('active'));
        if (openedMegaMenu && (event.key === 'Escape' || event.key === 'Esc')) {
            closeMegaMenu(openedMegaMenu);
        }
    }

    function isOpen(menuitem) {
        if (!menuitem || !menuitem.getAttribute('aria-expanded')) return false;
        return menuitem.getAttribute('aria-expanded') === 'true';
    }

    function toggleSticky() {
        el.classList[window.scrollY > 100 ? 'add' : 'remove']('sticky');

        if (el.classList.contains('transparent') && !el.classList.contains('mobile-menu-active')) {
            if (window.scrollY > 100) {
                toggleButtons.forEach(button => {
                    button.setAttribute('class', button.getAttribute('class').replace('-light', '-dark'));
                });
                actionLinks.forEach(button => {
                    button.setAttribute('class', button.getAttribute('class').replace('-light', ' light'));
                });
            } else {
                toggleButtons.forEach(button => {
                    button.setAttribute('class', button.getAttribute('class').replace('-dark', '-light'));
                });
                actionLinks.forEach(button => {
                    button.setAttribute('class', button.getAttribute('class').replace(' light', '-light'));
                });
            }
        }
    }

    megaMenus.forEach(megaMenu => {
        const { toggler, viewport, element } = megaMenu;

        if (viewport === 'desktop') {
            toggler.addEventListener('mouseenter', () => {
                clearTimeout(closeTimeout);
                openMegaMenu(megaMenu);
            });
            element.addEventListener('mouseenter', () => {
                clearTimeout(closeTimeout);
                openMegaMenu(megaMenu);
            });

            toggler.addEventListener('mouseleave', () => {
                closeTimeout = setTimeout(() => {
                    if (!checkAnyMegaMenuHovered()) {
                        closeMegaMenu(megaMenu);
                    }
                }, 200);
            });
            element.addEventListener('mouseleave', () => {
                closeTimeout = setTimeout(() => {
                    if (!checkAnyMegaMenuHovered()) {
                        closeMegaMenu(megaMenu);
                    }
                }, 200);
            });
        } else {
            toggler.addEventListener('click', () => openMegaMenu(megaMenu));

            const closeButton = element.querySelector('.js-close');
            if (closeButton) {
                closeButton.addEventListener('click', () => closeMegaMenu(megaMenu));
                mobileMenuToggler.addEventListener('click', () => closeMegaMenu(megaMenu));
            }
        }
    });

    if (mobileMenuToggler && mobileMenu) {
        mobileMenuToggler.addEventListener('click', () => {
            el.classList.toggle('mobile-menu-active');
            mobileMenuToggler.setAttribute('aria-expanded', !isOpen(mobileMenuToggler));
            mobileMenuToggler.classList.toggle('active');
            mobileMenu.classList.toggle('active');

            scrollLock[mobileMenuToggler.classList.contains('active') ? 'lock' : 'unlock']();

            toggleButtons.forEach(button => {
                if (el.classList.contains('transparent') && !el.classList.contains('sticky')) {
                    if (button.classList.contains('style-light')) {
                        button.setAttribute('class', button.getAttribute('class').replace('-light', '-dark'));
                    } else {
                        button.setAttribute('class', button.getAttribute('class').replace('-dark', '-light'));
                    }
                }
            });
        });
    }

    if (secondaryMenuToggler && secondaryMenu) {
        secondaryMenuToggler.addEventListener('click', () => {
            el.classList.toggle('secondary-menu-active');
            secondaryMenuToggler.setAttribute('aria-expanded', !isOpen(secondaryMenuToggler));
            secondaryMenuToggler.classList.toggle('active');
            secondaryMenu.classList.toggle('active');

            scrollLock[secondaryMenuToggler.classList.contains('active') ? 'lock' : 'unlock']();

            toggleButtons.forEach(button => {
                if (el.classList.contains('transparent') && !el.classList.contains('sticky')) {
                    if (button.classList.contains('style-light')) {
                        button.setAttribute('class', button.getAttribute('class').replace('-light', '-dark'));
                    } else {
                        button.setAttribute('class', button.getAttribute('class').replace('-dark', '-light'));
                    }
                }
            });
        });
    }

    menuLinks.forEach(navItem => {
        navItem.addEventListener('keydown', e => {
            if (e.key === 'ArrowLeft' || e.keyCode === 37 || e.key === 'ArrowRight' || e.keyCode === 39) {
                const focusedItem = document.activeElement;
                if (focusedItem) {
                    const currentIndex = Array.from(menuLinks).indexOf(focusedItem);

                    if (e.key === 'ArrowLeft' || e.keyCode === 37) {
                        if (currentIndex > 0) {
                            menuLinks[currentIndex - 1].focus();
                        }
                    }
                    if (e.key === 'ArrowRight' || e.keyCode === 39) {
                        if (currentIndex < menuLinks.length - 1) {
                            menuLinks[currentIndex + 1].focus();
                        }
                    }
                }
            }
        });
    });

    el.addEventListener('focusout', event => {
        setTimeout(() => {
            if (el.contains(event.relatedTarget)) return;
            if (event.toggler && isOpen(event.toggler)) {
                closeMegaMenu(event.toggler);
            }
        }, 100);
    });

    window.addEventListener('resize', () => {
        if (window.screen.availWidth >= 1200) {
            if (mobileMenuToggler && mobileMenuToggler.classList.contains('active')) {
                mobileMenuToggler.click();
            }
            if (secondaryMenuToggler && secondaryMenuToggler.classList.contains('active')) {
                secondaryMenuToggler.click();
            }
        }
    });

    window.addEventListener('scroll', () => toggleSticky());
    toggleSticky();

    el.querySelector('.js-search') && el.querySelector('.js-search').addEventListener('click', ({ currentTarget }) => {
        const form = el.querySelector('.js-search-desktop');
        if (!form) return;

        el.classList.toggle('active');
        form.classList.toggle('is-active');
        currentTarget.classList.toggle('is-active');
    });

    const accordion = el.querySelector('.js-accordion');

    function closeItem(item) {
        if (!item.classList.contains('is-active')) return;
        item.classList.remove('is-active');
        item.querySelector('.js-item-content').removeAttribute('style');
    }

    function openItem(item) {
        if (item.classList.contains('is-active')) return;
        item.classList.add('is-active');
        updateActiveItemHeight();
    }

    function updateActiveItemHeight() {
        const activeItem = el.querySelector('.js-item.is-active');
        if (!activeItem) return;
        const contentHeight = activeItem.querySelector('.js-item-content-wrapper').clientHeight;
        activeItem.querySelector('.js-item-content').style.height = `${contentHeight}px`;
    }

    if (accordion) {
        accordion.addEventListener('click', ({ target }) => {
            const toggle = target.closest('.js-item-toggle');
            if (!toggle) return;

            const item = toggle.parentNode.parentNode;
            if (item.classList.contains('is-active')) {
                closeItem(item);
            } else {
                const activeItem = el.querySelector('.js-item.is-active');
                if (activeItem) closeItem(activeItem);
                openItem(item);
            }
        });
    }

    let updateTimeout = false;
    window.addEventListener('resize', () => {
        clearTimeout(updateTimeout);
        updateTimeout = setTimeout(() => updateActiveItemHeight(), 150);
    });
});
